import { PicProofEnum } from 'types/common';
import { printf } from 'utils/i18n';
import { AllowSizeOption, AllowUploadItemType } from './type';

const imgExt = ['jpg', 'jpeg', 'png', 'gif'];

export const IMG_MAX_SIZE = 50 * 1024 * 1024; // 默认限制最大50MB：https://tigertech.feishu.cn/wiki/UfEKwz1gviZMaqkkZG6cORyvn2e
export const IMG_MIN_SIZE = 0;

const imgAcceptConfig: AllowUploadItemType['accepts'][number] = {
    accept: 'image/*',
    ext: imgExt,
    sizeOption: {
        min: IMG_MIN_SIZE,
        max: IMG_MAX_SIZE,
        tip: printf(__('The image size should be between %s and %s'), '0KB', '50MB')
    }
};

export const allowUploadTypeConfig: Record<'onlyPic' | 'allowPicAndPDF', AllowUploadItemType> = {
    onlyPic: {
        accepts: [imgAcceptConfig],
        allowText: __('抱歉，图片格式暂不支持，请上传 jpg, jpeg, png格式的图片')
    },
    allowPicAndPDF: {
        accepts: [
            imgAcceptConfig,
            {
                accept: 'application/pdf',
                ext: ['pdf']
            }
        ],
        allowText: __('抱歉，文件格式暂不支持，请上传 jpg, jpeg, png, pdf格式文件')
    }
};

export function getAccepts(type?: PicProofEnum, sizeOption?: AllowSizeOption) {
    const allowPicAndPDF: PicProofEnum[] = [PicProofEnum.PIC_EXEMPTION, PicProofEnum.INQUIRY];
    let allowUploadItem = allowUploadTypeConfig.onlyPic;

    if (type && allowPicAndPDF.includes(type)) {
        allowUploadItem = allowUploadTypeConfig.allowPicAndPDF;
    }

    if (sizeOption) {
        allowUploadItem.accepts = allowUploadItem.accepts.map(item => ({
            ...item,
            sizeOption
        }));
    }

    return allowUploadItem;
}

export const isImageFile = (url: string) => {
    return /(?:jpe?g|png|gif)$/i.test(url);
};
